var React = require('react');

function ArrowLeft (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"currentColor","fillRule":"evenodd","clipRule":"evenodd","d":"M18.63 1.478L17.16-.025 6.862 10.497l-.004-.004L5.39 11.99l.005.005L5.39 12l1.473 1.503.004-.005 10.255 10.477 1.465-1.496L8.334 12"}));
}

ArrowLeft.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = ArrowLeft;

ArrowLeft.default = ArrowLeft;
